import React, { useMemo } from 'react';

import { missingLinkedEntryId, useAddressHash } from '../../hooks/useLinkedEntry';

/**
 * A link to one entry of a repeating group (`#entry-<id>`) whose entry is not
 * on this item (KPR-690): the item opens as usual and this one line says why
 * nothing is marked. The entry may have been removed, never have existed, or be
 * one this person cannot see — the words cover all three and tell none apart.
 * Nothing at all when the item has no repeating group the person can see.
 */
export default function LinkedEntryNotice({ groupDefs, elements, className = '' }) {
	const hash = useAddressHash();
	const missing = useMemo(() => missingLinkedEntryId(hash, groupDefs, elements), [hash, groupDefs, elements]);
	if (!missing) return null;
	return (
		<div className={`linked-entry-notice ${className}`.trim()} role="status" data-testid="linked-entry-notice">
			That entry is no longer on this item, or you cannot see it.
		</div>
	);
}
